import Badge from '@mui/material/Badge';
import { stringAvatar } from '@stack/helpers';

import CloneElement from '../CloneElement';

import { AvatarOnlineProps } from './props';
import { StyledAvatar, StyledAvatarOnlineStatus } from './styled';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const AvatarOnline: React.FC<AvatarOnlineProps> = (props) => {
  const {
    name,
    avatar,
    color,
    size = 40,
    statusPosition = ['bottom', 'right'],
    status = 'online',
    onClick,
    onClickStatus,
  } = props;

  // =============== VIEWS
  const renderAvatar = () => {
    if (typeof avatar === 'string') {
      return (
        <StyledAvatar
          skin="light"
          size={size}
          color={color}
          src={avatar}
          alt={name}
          onClick={onClick}
        />
      );
    }
    if (avatar) {
      return <CloneElement onClick={onClick}>{avatar}</CloneElement>;
    }
    return (
      <StyledAvatar
        skin="light"
        size={size}
        color={color}
        alt={name}
        onClick={onClick}
      >
        {stringAvatar(name as string).children}
      </StyledAvatar>
    );
  };

  return (
    <Badge
      overlap="circular"
      invisible={status === 'none'}
      sx={{ ml: 2, cursor: 'pointer' }}
      onClick={onClickStatus}
      badgeContent={<StyledAvatarOnlineStatus status={status} />}
      anchorOrigin={{
        vertical: statusPosition?.[0] ?? 'top',
        horizontal: statusPosition?.[1] ?? 'right',
      }}
    >
      {renderAvatar()}
    </Badge>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export * from './props';
export default AvatarOnline;
